// LoyaBoost v1: request-id propagation is not wired in. These stubs preserve the API surface
// so dependent utilities continue to type-check; v2 can restore proper request-id propagation.

export function getRequestIdFromDom(): string | undefined {
  return undefined;
}

export function getRequestIdFromHeaders(
  _headers: Record<string, unknown> | Headers | undefined,
): string | undefined {
  return undefined;
}

export function getRequestIdFromCookieHeader(
  _cookieHeader: unknown,
): string | undefined {
  return undefined;
}

export function getRequestIdFromRequest(_req: Request): string | undefined {
  return undefined;
}
